import { useState, useEffect } from 'react';
import { schoolInfo as defaultSchoolInfo } from '../data/navigationData';

let cachedSchoolInfo = null;
const listeners = new Set();

export function useSchoolInfo() {
  const [info, setInfo] = useState(cachedSchoolInfo || defaultSchoolInfo);

  useEffect(() => {
    listeners.add(setInfo);

    if (!cachedSchoolInfo) {
      fetch('/_api/public/content/skoleinformation')
        .then((res) => (res.ok ? res.json() : null))
        .then((data) => {
          if (Array.isArray(data) && data[0]) {
            const item = data[0];
            const updated = {
              ...defaultSchoolInfo,
              name: item.skolenavn || defaultSchoolInfo.name,
              tagline: item.slagord || defaultSchoolInfo.tagline,
              cvr: item.cvr || defaultSchoolInfo.cvr,
              phone: item.telefon || defaultSchoolInfo.phone,
              phoneRaw: (item.telefon || defaultSchoolInfo.phone).replace(/\s+/g, ''),
              email: item.email || defaultSchoolInfo.email,
              lederEmail: item.leder_email || defaultSchoolInfo.lederEmail,
              address: item.adresse || defaultSchoolInfo.address,
              city: item.postnr_by || defaultSchoolInfo.city,
              fullAddress: `${item.adresse || defaultSchoolInfo.address}, ${item.postnr_by || defaultSchoolInfo.city}`,
              hoursFritter: item.aabningstider_fritter || defaultSchoolInfo.hoursFritterMonThu,
              hoursKontor: item.aabningstider_kontor || "Mandag – fredag kl. 07.45 – 15.00",
              logoUrl: item.logo?.[0] || defaultSchoolInfo.logoUrl
            };
            cachedSchoolInfo = updated;
            listeners.forEach((fn) => fn(updated));
          }
        })
        .catch(() => {});
    }

    return () => {
      listeners.delete(setInfo);
    };
  }, []);

  return info;
}
